module.exports = __webpack_public_path__ + "img/selectedBase.5ba1eaca.png";